<div class="section-container">
  <div class="header-container">
    <app-title-field
      [title]="'Leaves'"
      [icon]="'personCheckIcon'"
      [iconVariant]="'outlined'"
    ></app-title-field>
    <app-button-group
      [label]="'Apply Leave'"
      [buttonType]="'Secondary'"
      [buttonUseCase]="'Apply Leave'"
      (onEmit)="applyLeave()"
    >
    </app-button-group>
  </div>

  <app-table
    [columnDefs]="LEAVES_COLUMNS"
    [rowData]="leavesData"
    [gridOptions]="gridOptions"
    [enableActions]="tableConfig.enableActions || false"
    [enablePagination]="tableConfig.enablePagination ?? true"
    [paginationPageSize]="tableConfig.paginationPageSize || 10"
    [enableRowSelection]="tableConfig.enableRowSelection || false"
    [rowSelectionMode]="tableConfig.rowSelectionMode || 'multiple'"
    [enableSorting]="tableConfig.enableSorting ?? true"
    [enableFiltering]="tableConfig.enableFiltering ?? true"
    [enableColumnResize]="tableConfig.enableColumnResize ?? true"
    [height]="maxTableHeight"
    [frameworkComponents]="frameworkComponents"
  >
  </app-table>
  <app-contractor-apply-leave 
  [showModal]="showApplyLeaveModal"
  [quarterlyLimit]="quarterlyLimit"
  (closeModal)="closeApplyLeaveModal()"
  (dataSaved)="onDataSaved()">
</app-contractor-apply-leave>
</div>
